var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwoStars = function SvgTwoStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "illus-clr-2",
    d: "M14.5 0a.5.5 0 0 1 .49.402l.108.539A2.5 2.5 0 0 0 17.06 2.9l.54.109a.5.5 0 0 1 0 .98l-.54.108A2.5 2.5 0 0 0 15.1 6.06l-.109.54a.5.5 0 0 1-.98 0l-.108-.54A2.5 2.5 0 0 0 11.94 4.1l-.54-.109a.5.5 0 0 1 0-.98l.54-.108A2.5 2.5 0 0 0 13.9.94L14.01.4A.5.5 0 0 1 14.5 0ZM7.5 3a.5.5 0 0 1 .482.368L8.43 5.01a6.5 6.5 0 0 0 4.56 4.561l1.642.448a.5.5 0 0 1 0 .964l-1.641.448a6.5 6.5 0 0 0-4.561 4.56l-.448 1.642a.5.5 0 0 1-.964 0L6.57 15.99a6.5 6.5 0 0 0-4.56-4.561l-1.642-.448a.5.5 0 0 1 0-.964L2.01 9.57A6.5 6.5 0 0 0 6.57 5.01l.448-1.642A.5.5 0 0 1 7.5 3Z"
  })));
};
export default SvgTwoStars;